import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
    *, *::before, *::after {
        box-sizing: border-box;
    }

    body {
        margin: 0;
        padding: 0;
        font-family: 'Hanken Grotesk', sans-serif;
        font-weight: 400;
        color: ${({ theme }) => theme.colors.ink};
    }

    html, body, #root {
        min-height: 100%;
        background: ${({ theme }) => theme.colors.bgCream};
    }

    /* Material Symbols Rounded helper (también en index.html) */
    .msr {
        font-family: 'Material Symbols Rounded';
        font-weight: normal;
        font-style: normal;
        line-height: 1;
        letter-spacing: normal;
        text-transform: none;
        display: inline-block;
        white-space: nowrap;
        direction: ltr;
        -webkit-font-feature-settings: 'liga';
        -webkit-font-smoothing: antialiased;
        vertical-align: middle;
        user-select: none;
    }
    .msr-fill { font-variation-settings: 'FILL' 1; }

    ::-webkit-scrollbar { width: 0; height: 0; background: transparent; }
    * { scrollbar-width: none; }
`;

export default GlobalStyle;
